import { useLayoutEffect } from "react";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import { stageSlugToStageCode } from "src/utils";

const stageSlugs = Object.keys(stageSlugToStageCode);
const stageSlugRegEx = new RegExp(`/(${stageSlugs.join("|")})`);

export function useStripStage() {
  const location = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (!stageSlugRegEx.test(location.pathname)) return;
    navigate(
      { pathname: location.pathname.replace(stageSlugRegEx, ""), search: location.search, hash: location.hash },
      { replace: true, state: location.state },
    );
  }, [location.pathname, location.search, location.hash, location.state, navigate]);
}
